import { OptionDto } from "@/dtos";
import { OperatorsType } from "@/helpers/types";

const operatorsType = [
    { value: parseInt(OperatorsType.PRINCIPAL), label: 'PRINCIPAL' },
    { value: parseInt(OperatorsType.ASSISTANT), label: 'ASISTENTE' }
] as OptionDto[];